import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "loan-details-section-wrapper" }
const _hoisted_2 = {
  class: "loan-details-section",
  ref: "schoolConfirmationRef",
  id: "schoolConfirmation"
}
const _hoisted_3 = { class: "loan-details-section-header" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "loan-details-section-content two-column-grid" }
const _hoisted_6 = {
  class: "info-section",
  id: "school"
}
const _hoisted_7 = { class: "info" }
const _hoisted_8 = {
  class: "info-section",
  id: "graduationDate"
}
const _hoisted_9 = { class: "info" }
const _hoisted_10 = {
  class: "info-section",
  id: "academicTerms"
}
const _hoisted_11 = { class: "info" }
const _hoisted_12 = {
  class: "loan-details-section",
  ref: "loanTermsRef",
  id: "interestRateAndLoanTerms"
}
const _hoisted_13 = { class: "loan-details-section-header" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "loan-details-section-content two-column-grid" }
const _hoisted_16 = {
  class: "info-section",
  id: "loanAmount"
}
const _hoisted_17 = { class: "info" }
const _hoisted_18 = {
  class: "info-section",
  id: "loanAmountPerTerm"
}
const _hoisted_19 = { class: "info" }
const _hoisted_20 = {
  class: "info-section",
  id: "repaymentType"
}
const _hoisted_21 = { class: "info" }
const _hoisted_22 = {
  class: "info-section",
  id: "rateSelection"
}
const _hoisted_23 = { class: "info" }
const _hoisted_24 = {
  class: "info-section",
  id: "inSchoolPayments"
}
const _hoisted_25 = { class: "info-title" }
const _hoisted_26 = { class: "info" }
const _hoisted_27 = {
  class: "info-section",
  id: "postGradPayments"
}
const _hoisted_28 = { class: "info-title" }
const _hoisted_29 = { class: "info" }

import { computed } from "vue";
import { useStore } from "vuex";
import { PelLoanConfigurationDetails } from "@/models/pel";
import useApplicationData from "@/composables/useApplicationData";


export default /*@__PURE__*/_defineComponent({
  __name: 'PelLoanConfigurationDetailsSection',
  props: {
  loading: { type: Boolean, required: true },
},
  emits: ["complete", "close", "cancel", "openSchoolConfirmationModal", "openLoanConfigurationModal"],
  setup(__props, { emit: __emit }) {

const props = __props;

const store = useStore();

const emit = __emit;

const { isValidProfessionalGradFlow } = useApplicationData();

const pelDetails = computed<PelLoanConfigurationDetails>(
  () => store.state.loanConfigurationModule.applicationInfo,
);

const loanAmount = computed<string>(() => pelDetails.value.loanAmountDisplay);

const loanAmountPerTerm = computed<string>(() => pelDetails.value.loanAmountPerTermDisplay);

const schoolName = computed<string>(() => pelDetails.value.schoolName);

const graduationDate = computed<string>(() => pelDetails.value.graduationDateDisplay);

const academicTerms = computed<string>(() => pelDetails.value.academicTerms);

const monthlyInSchoolPaymentLabel = computed<string>(() => {
  const label = pelDetails.value?.monthlyInSchoolPaymentLabel || "In-School";

  if (isValidProfessionalGradFlow.value) {
    return `${label} Monthly Est. Payments`;
  }

  return `${label} Monthly Payments`;
});

const monthlyPostSchoolPaymentLabel = computed<string>(() => {
  const label = pelDetails.value?.monthlyPostSchoolPaymentLabel || "Post-Grad";

  if (isValidProfessionalGradFlow.value) {
    return `${label} Monthly Est. Payments`;
  }

  return `${label} Monthly Payments`;
});

// Methods
function openSchoolConfirmationModal() {
  emit("openSchoolConfirmationModal", true);
}

function openLoanConfigurationModal() {
  emit("openLoanConfigurationModal", true);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[0] || (_cache[0] = _createTextVNode(" School Confirmation ", -1)),
          _createElementVNode("a", {
            class: "edit-loan-config-link",
            href: "#/",
            onClick: openSchoolConfirmationModal,
            disabled: __props.loading
          }, "Edit", 8, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _cache[1] || (_cache[1] = _createElementVNode("p", { class: "info-title" }, "School", -1)),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("p", null, _toDisplayString(schoolName.value), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[2] || (_cache[2] = _createElementVNode("p", { class: "info-title" }, [
              _createTextVNode("Graduation Date "),
              _createElementVNode("span", { class: "error" }, "*")
            ], -1)),
            _createElementVNode("div", _hoisted_9, _toDisplayString(graduationDate.value), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _cache[3] || (_cache[3] = _createElementVNode("p", { class: "info-title" }, "Academic Term(s)", -1)),
            _createElementVNode("div", _hoisted_11, _toDisplayString(academicTerms.value), 1)
          ])
        ])
      ], 512)
    ], 512), [
      [_vShow, !__props.loading]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _cache[4] || (_cache[4] = _createTextVNode(" Interest Rate & Loan Terms ", -1)),
        _createElementVNode("a", {
          class: "edit-loan-config-link",
          href: "#/",
          onClick: openLoanConfigurationModal,
          disabled: __props.loading
        }, "Edit", 8, _hoisted_14)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _cache[5] || (_cache[5] = _createElementVNode("p", { class: "info-title" }, "Loan Amount", -1)),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("p", null, _toDisplayString(loanAmount.value), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _cache[6] || (_cache[6] = _createElementVNode("p", { class: "info-title" }, "Amount Per Academic Term", -1)),
          _createElementVNode("div", _hoisted_19, _toDisplayString(loanAmountPerTerm.value), 1)
        ]),
        _createElementVNode("div", _hoisted_20, [
          _cache[7] || (_cache[7] = _createElementVNode("p", { class: "info-title" }, "Repayment Type", -1)),
          _createElementVNode("div", _hoisted_21, _toDisplayString(pelDetails.value?.repaymentTypeDisplay), 1)
        ]),
        _createElementVNode("div", _hoisted_22, [
          _cache[8] || (_cache[8] = _createElementVNode("p", { class: "info-title" }, "Rate Selection", -1)),
          _createElementVNode("div", _hoisted_23, _toDisplayString(pelDetails.value?.rateSelectionDisplay), 1)
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("p", _hoisted_25, _toDisplayString(monthlyInSchoolPaymentLabel.value), 1),
          _createElementVNode("div", _hoisted_26, _toDisplayString(pelDetails.value.monthlyInSchoolPaymentsDisplay), 1)
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("p", _hoisted_28, _toDisplayString(monthlyPostSchoolPaymentLabel.value), 1),
          _createElementVNode("div", _hoisted_29, _toDisplayString(pelDetails.value.monthlyPostGradPaymentsDisplay), 1)
        ])
      ]),
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "disclaimer" }, [
        _createElementVNode("p", null, [
          _createTextVNode(" Payment Estimates – See Your Approval Disclosure in your Legal Packet and your Final Disclosure after school certification is completed for more details. "),
          _createElementVNode("b", null, [
            _createElementVNode("i", null, "The amount shown for In-School Monthly Payments is an average over the in-school period.")
          ]),
          _createTextVNode(" Actual payment amounts will vary based on the number of days in a month, the days between loan disbursements and any variable interest rate. ")
        ])
      ], -1))
    ], 512), [
      [_vShow, !__props.loading]
    ])
  ], 64))
}
}

})